<template>
    <div class="page page_xiaofei">
        <van-tabs v-model="active" @click="onTabsClick">
            <van-tab title="全部" :name="-1"></van-tab>
            <van-tab title="商品" :name="0"></van-tab>
            <!-- <van-tab title="视频" ></van-tab> -->
            <van-tab title="门票" :name="3"></van-tab>
        </van-tabs>
        <!--  -->
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
                <div class="list">
                    <div class="item" v-for="item in dataList" :key="item.id">
                        <img :src="(item != null && item.touserdata != null && item.touserdata.thumb!=null) ? ($publicData.withHttpStart(item.touserdata.thumb) ? item.touserdata.thumb : imageUrl+item.touserdata.thumb) : $publicData.defaultTouxiang" alt="" class="thumb">
                        <div class="item_r">
                            <div class="item_nr">
                                <div class="title slh_s">{{ item.mark }}</div>
                                <div class="time">{{ item.created_at }}</div>
                            </div>
                            <div class="price"><span class="tag_cash">{{ item.type==1?'+':'-' }}¥</span>{{ item.price }}</div>
                        </div>
                    </div>
                </div>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "my-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            active: -1,
            imageUrl: this.$publicData.uploadImage,
            dataList: [],
            token: '',
            finished: false,
            page: 1,
            size: 10,
            loading: false,
            refreshing: false,
        };
    },
    created: function () {
        if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
            var params = {'data':{'naviTitle':'匠人'}}
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
                this.onRefresh();
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.onRefresh();
        }
        // // 获取列表
        // this.getData();
    },
    methods: {
        onTabsClick(name,title) {
			this.active = name
			console.log('name',name)
            this.onRefresh()
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.page = 1
            this.getData();
        },
        // 获取列表
        getData() {
            if (this.token == null || this.token == undefined || this.token == '') {
                return
            }
            var param = {
                token: this.token,
                page: this.page,
                size: this.size
            }
            if (this.active != -1) {
                param['sorce'] = this.active
            }
            this.$api.my.tradeRecord(param).then(res=>{
                if(res.code == 200){
                    var list = res.result;
                    var old = this.dataList
                    if (this.page == 1) {
                        old = []
                    }
                    for (let i = 0; i < list.length; i++) {
                        var touserdata = list[i].touserdata
                        // if (touserdata.thumb == null) {
                        //     touserdata.thumb = ''
                        // }
                        // if (touserdata.nickname == null) {
                        //     touserdata.nickname = ''
                        // }
                        list[i].touserdata = touserdata
                        old.push(list[i])
                    }
                    this.dataList = old
                    if (list.length < this.size) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }
                } else {
                    this.finished = true
                    this.$toast(res.message)
                }
                this.page++;
                this.refreshing = false
                this.loading = false;
            })
        },

    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
